<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fmtitle">Acknowledgements</h2>
<p class="noindentt">I owe a great deal of gratitude to many supportive, influential and encouraging people, whose belief in me has been instrumental during the production of this book.</p>
<p class="noindentt">My husband, Victor. Your support means so much to me. Thank you for your patience and always taking the time to listen to my fears, hopes, dreams and woes. My love for you knows no bounds.</p>
<p class="noindentt">My parents, Mary and David, for their continued support and belief in me. My brother, Conor, for his encouragement from the very beginning of my writing career.</p>
<p class="noindentt">My mother-in-law, Vera. Your belief in me is overwhelming, and I am eternally grateful for your support. You have given me my life’s greatest gift. I owe you more thanks than can ever be expressed in the English language.</p>
<p class="noindentt">My friend Sandra Vasoli, who believes in me far more than I will ever believe in myself. You have shown me true kindness, guidance and friendship. You are a fountain of knowledge!</p>
<p class="noindentt">My supportive work colleagues, Mariana, Filipe and Sanja, who have had put up with perhaps hours of history lessons which they probably didn’t want!</p>
<p class="noindentt">My dearest friend Carina. Thank you for all your love, support and laughs!</p>
<p class="noindentt">My editor Sarah-Beth Watkins, and all from Pen and Sword publishing, who have contributed to the production of this book. Particular thanks to Claire Hopkins for her patience and encouragement throughout this journey.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?07e3a5ed